module.exports = __webpack_public_path__ + "static/media/brospipe-lite.82f3b93a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/brospipe-lite.gif
// module id = 249
// module chunks = 0